import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as MapboxDraw from '@mapbox/mapbox-gl-draw';
import * as mapboxgl from 'mapbox-gl';
import * as mapbox from 'mapbox-gl';
import { environment } from 'src/environments/environment';

export interface DialogData {
  address: string;
  GeoFenceJson: string;
}

@Component({
  selector: 'app-dialog-map',
  templateUrl: './dialog-map.component.html',
  styleUrls: ['./dialog-map.component.scss']
})
export class DialogMapComponent implements OnInit, AfterViewInit {
  Draw: any;
  map: mapbox.Map;
  GeoFenceJson: any;
  changeLocations: any = null;
  currentId: string | undefined;
  style = `mapbox://styles/mapbox/streets-v10`;

  zoom = 3;
  lng = -74.080833;
  lat = 4.598889;

  private deleted = false;
  private readonly CO_BOUNDS: [[number, number], [number, number]] = [[-79.1, -4.6], [-66.4, 13.6]];

  constructor(
    public dialogRef: MatDialogRef<DialogMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.GeoFenceJson = this.data.GeoFenceJson;
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    (mapboxgl as any).accessToken = environment.api.MapboxAccessToken;
    const container = document.getElementById('map-drag');

    try {
      this.map = new mapboxgl.Map({
        container,
        style: this.style,
        center: [this.lng, this.lat],
        zoom: this.zoom
      });
    } catch (e) {
      return;
    }

    this.Draw = new (MapboxDraw as any)({
      displayControlsDefault: false,
      controls: { polygon: true, trash: true }
    });
    this.map.addControl(this.Draw, 'top-right');

    this.map.once('load', () => {
      setTimeout(() => this.map.resize(), 0);

      if (this.GeoFenceJson && Array.isArray(this.GeoFenceJson.coordinates) && this.GeoFenceJson.coordinates.length > 0) {
        try {
          this.currentId = this.Draw.add({
            type: 'Feature',
            geometry: this.GeoFenceJson,
            properties: {}
          });
          this.fitToGeometry(this.GeoFenceJson, 32);
        } catch { }
      } else {
        this.map.fitBounds(this.CO_BOUNDS, { padding: 32, maxZoom: 8, duration: 0 });
      }

      this.map.on('draw.create', (e: any) => {
        this.deleted = false;
        this.changeLocations = e;
        const geom = e?.features?.[0]?.geometry;
        if (geom) { this.fitToGeometry(geom, 32); }
      });

      this.map.on('draw.update', (e: any) => {
        this.deleted = false;
        this.changeLocations = e;
        const geom = e?.features?.[0]?.geometry;
        if (geom) { this.fitToGeometry(geom, 32); }
      });

      this.map.on('draw.delete', () => {
        this.changeLocations = null;
        this.deleted = true;
      });
    });
  }

  get canSave(): boolean {
    return this.deleted
      || (this.changeLocations?.features?.length > 0)
      || (!!this.GeoFenceJson && Array.isArray(this.GeoFenceJson.coordinates));
  }

  private fitToGeometry(geometry: any, padding = 24) {
    if (!geometry?.coordinates) { return; }

    const bounds = new mapboxgl.LngLatBounds();

    const walk = (coords: any) => {
      if (typeof coords?.[0] === 'number') {
        bounds.extend([coords[0], coords[1]]);
        return;
      }
      for (const c of coords) { walk(c); }
    };

    walk(geometry.coordinates);

    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds, { padding, maxZoom: 18, duration: 0 });
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save(): void {
    if (this.deleted) {
      const type = this.GeoFenceJson?.type ?? 'Polygon';
      this.dialogRef.close({ type, coordinates: [] });
      return;
    }

    if (this.changeLocations?.features?.length > 0) {
      const g = this.changeLocations.features[0].geometry;
      this.dialogRef.close({ type: g.type, coordinates: g.coordinates });
      return;
    }

    if (this.GeoFenceJson) {
      this.dialogRef.close(this.GeoFenceJson);
      return;
    }
    this.dialogRef.close({ type: 'Polygon', coordinates: [] });
  }

}
